import React, { useEffect } from 'react';
import {
  FaBoxOpen,
  FaUserCheck,
  FaUniversity,
  FaLaptopCode,
  FaBullhorn,
  FaUserTie,
} from 'react-icons/fa';
// Removed: import AOS from 'aos'; // AOS is initialized in App.js
// Removed: import 'aos/dist/aos.css'; // CSS is imported in App.js
import './Homeservices.css'; // Keep your custom CSS
import { Link } from 'react-router-dom';

const services = [
  {
    icon: <FaBoxOpen className="icon text-warning" />,
    title: 'Equipment Recovery',
    description: 'Asset recovery of customer premise equipment with proper tracking.',
    animation: 'flip-left',
    path: '/retention-cpe',
  },
  {
    icon: <FaUserCheck className="icon text-success" />,
    title: 'Customer Verification',
    description: 'Trusted process to verify customer identity and enterprise accounts.',
    animation: 'zoom-in',
    path: '/customer-verification',
  },
  {
    icon: <FaUniversity className="icon text-danger" />,
    title: 'Financial Services',
    description: 'Debt collection and recovery for both B2B and B2C finance sectors.',
    animation: 'flip-left',
    path: '/financial-services',
  },
  
  {
    icon: <FaUserTie className="icon text-secondary" />,
    title: 'HR Services',
    description: 'Hiring, Staffing, Payroll, Compliance, and Background Verification (BGV).',
    animation: 'zoom-in',
    path: '/hr-services',
  },
];

const Homeservices = () => {
  useEffect(() => {
    // Removed: AOS.init({ duration: 1000, once: true });
    // This is now handled globally in App.js
    // No specific local AOS setup needed here.
  }, []);

  return (
    // The overflowX: 'hidden' should primarily be on a higher-level wrapper like in App.js.
    // However, for extra safety within this component's content area if it still causes issues,
    // you could add it to the 'homeservices-section' div's style or its CSS class.
    // For now, let's trust the App.js fix and focus on proper Bootstrap usage.
    <div className="container py-5 homeservices-section">
      <h2 className="text-center text-primary fw-bold mb-4 display-5">Our Services</h2>
      <p className="text-center mb-5 fs-5 text-muted">
we offer a full suite of professional solutions designed to drive business success. Our core services include:
      </p>

      <div className="row justify-content-center"> {/* Added justify-content-center for better centering on smaller screens */}
        {services.map((service, index) => (
          <div
            className="col-12 col-md-6 col-lg-4 mb-4"
            data-aos={service.animation}
            key={index}
          >
            <Link to={service.path} className="text-decoration-none text-dark">
              <div className="card service-card h-100 shadow-sm border-0 d-flex flex-column"> {/* Added d-flex flex-column for consistent height */}
                <div className="card-body text-center d-flex flex-column justify-content-center align-items-center"> {/* Centered content vertically and horizontally */}
                  <div className="mb-3 display-4">{service.icon}</div>
                  <h5 className="card-title fw-bold fs-4">{service.title}</h5>
                  <p className="card-text fs-6 flex-grow-1">{service.description}</p> {/* flex-grow-1 ensures p takes available space */}
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Homeservices;